import Slider from 'react-slick';
import React, { useEffect, useState, useRef } from 'react';
import { ImageDetail } from '../types';
import { useTranslation } from 'react-i18next';

interface ThumbnailSliderProps {
    images: ImageDetail[];
    activeIndex: number;
    setActiveIndex: (index: number) => void;
}

export const ThumbnailSlider: React.FC<ThumbnailSliderProps> = ({
    images,
    activeIndex,
    setActiveIndex,
}) => {

    const { t } = useTranslation();
    const sliderRef = useRef<Slider>(null);

    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(activeIndex, true);
        }
    }, [activeIndex]);

    // Calcola dinamicamente slidesToShow in base alla larghezza dello schermo
    const [slidesToShow, setSlidesToShow] = useState(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 576) return 3;
            if (window.innerWidth < 768) return 5;
            if (window.innerWidth < 992) return 6;
            if (window.innerWidth < 1200) return 7;
            return 9;
        }
        return 9;
    });

    // Aggiorna slidesToShow al resize
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 576) {
                setSlidesToShow(3);
            } else if (window.innerWidth < 768) {
                setSlidesToShow(5);
            } else if (window.innerWidth < 992) {
                setSlidesToShow(6);
            } else if (window.innerWidth < 1200) {
                setSlidesToShow(7);
            } else {
                setSlidesToShow(9);
            }   
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const baseSliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToScroll: 1,
        slidesToShow: slidesToShow,
        focusOnSelect: true,
        swipeToSlide: true,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnHover: true
    };

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <div className='slider slider-nav limit-height'>
            <Slider ref={sliderRef} {...baseSliderSettings} afterChange={(current) => {if (current !== activeIndex) {setActiveIndex(current)}}}
            >
                {images.map((img, index) => (
                    <div key={index} className="slick-slide" style={{ outline: "none" }}>
                        <img
                            className="img-fluid"
                            alt={`Thumbnail ${index + 1}`}
                            src={img.urlSmall ?? '/assets/images/no_image_small.jpg'}
                            style={{
                                cursor: "pointer",
                                objectFit: "cover"
                            }}
                            onClick={() => setActiveIndex(index)}
                            loading="lazy"
                            onError={(e) => {
                                e.currentTarget.src = '/assets/images/no_image_small.jpg';
                                e.currentTarget.alt = t('gallery.thumbnailAltFallback', 'Miniatura non disponibile');
                            }}
                        />
                    </div>
                ))}
            </Slider>
        </div>
    );
};